import { render } from "./LinkageChangeEmailComplete.vue?vue&type=template&id=0dd2eff2&ts=true"
import script from "./LinkageChangeEmailComplete.vue?vue&type=script&lang=ts"
export * from "./LinkageChangeEmailComplete.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3516746311/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__